import React, { useState } from "react";
import "./styles.scss";
import { getBankLogos, getSvgComponent } from "../../utils/svgUtils";
import CustomLoader from "../CustomLoader";

const BankSelectCard = ({
  data,
  selectable = false,
  onSelect,
  withoutBorder = false,
}) => {
  const [selectedBankId, setSelectedBankId] = useState(null);

  const handleSelect = (bankId, bank) => {
    if (selectable) {
      setSelectedBankId(bankId);
      onSelect?.(bank); // if onSelect is passed
    } else {
      setSelectedBankId(bankId);
      onSelect?.(bank);
    }
  };

  return (
    <>
      {data.length ? (
        <div
          className={`bank-select-card ${
            selectable ? "single-column" : "double-column"
          } ${withoutBorder ? "border-0" : ""}`}
        >
          {data.map((item, index) => {
            const isSelected = item.id
              ? selectedBankId === item.id
              : selectedBankId === item?.providerId;
            return (
              <div
                key={index}
                className={`bank-cards ${isSelected ? "selected" : ""}`}
                onClick={() => handleSelect(item.id ?? item?.providerId, item)}
              >
                <div className="bank-card-content">
                  <div className="logo-container">
                    <img
                      src={
                        item?.bank_icon
                          ? getSvgComponent(item?.bank_icon)
                          : getBankLogos(item?.providerId)
                      }
                      alt={item?.bank_name || "Bank Logo"}
                      className="bank-logo"
                    />
                  </div>
                  {selectable && (
                    <div className="bank-radio">
                      {isSelected && <div className="bank-radio-inner" />}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <CustomLoader visible={true} />
      )}
    </>
  );
};

export default BankSelectCard;
